import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames/bind";
import styles from "./ProductSlideshow.module.scss";
import { ChevronLeft, ChevronRight } from "lucide-react";

import ProductSilder from "../ProductSilder/ProductSilder";
import Button from "../ui/Button/Button";
import useTranslations from "../../hooks/useTranslations";

const cx = classNames.bind(styles);

function ProductSlideshow({
  column = false,
  showBtn = true,
  items = [],
  itemsPerPage = 4,
  title = "Necklaces",
  subtitle = "Adorn your ears with the new atmosphere.",
  showHeader = true,
}) {
  const currentTranslations = useTranslations(); // Sử dụng hook cho translations
  const [titleTranslations, setTitleTranslations] = useState(title);
  const [subtitleTranslations, setSubtitleTranslations] = useState(subtitle);
  
  // Refs for navigation buttons
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    if (!showHeader) {
      return;
    }
    if (!column) {
    
      setTitleTranslations(currentTranslations?.JewelryDropDown?.[title]);
      setSubtitleTranslations(currentTranslations?.title?.description_category);
    } else {
      // Khi column = true, sử dụng title và subtitle được truyền vào từ props
      setTitleTranslations(title);
      setSubtitleTranslations(subtitle);
    }
  }, [showHeader, title, subtitle, column, currentTranslations]);


  return (
    <div className={cx("product-slideshow")}>
      <div className={cx("slideshow-header",{"hide":!showHeader})}>
        {showHeader && (
          <div className={cx("header-content", `${column && "column"}`)}>
            <h3>{titleTranslations}</h3>
            <p>{subtitleTranslations}</p>
          </div>
        )}
        {showBtn && (
          <div className={cx("header-btn")}>
            <Button
              to={`/products/category/${title}`}
              content={` ${
                column
                  ? subtitleTranslations
                  : `${currentTranslations?.title?.shop_all}  ${titleTranslations}`
              } `}
              second={true}
              className={cx("btn")}
            />
          </div>
        )}
      </div>

      <div className={cx("slideshow-main")}>
        {/* Navigation buttons */}
        <button
          ref={prevRef}
          className={cx("nav-btn", "nav-prev")}
          aria-label="Previous slide"
        >
          <ChevronLeft size={24} />
        </button>
        
        <button
          ref={nextRef}
          className={cx("nav-btn", "nav-next")}
          aria-label="Next slide"
        >
          <ChevronRight size={24} />
        </button>
        
        <ProductSilder items={items} prevRef={prevRef} nextRef={nextRef} />
      </div>
    </div>
  );
}

export default ProductSlideshow;
